"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.box"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.fade-in"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var constructTabData = function constructTabData(_ref, template) {
  var total = _ref.total;

  if (!total) {
    return null;
  }

  var tabData = template.replace('[0]', total);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styled.TabData, null, tabData));
};

var TabMetric = function TabMetric(_ref2) {
  var _ref2$store = _ref2.store,
      pagination = _ref2$store.pagination,
      fetched = _ref2$store.fetched,
      template = _ref2.template;
  return /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    height: "14px"
  }, fetched && /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2["default"], null, /*#__PURE__*/_react["default"].createElement("div", null, constructTabData(pagination, template))));
};

TabMetric.sampleProps = {
  data: {
    fetched: true,
    pagination: {
      total: 10
    }
  },
  template: 'There are [0] responses'
};
var _default = TabMetric;
exports["default"] = _default;

//# sourceMappingURL=TableTabMetric.js.map